import React from 'react';
import { getHelperErrorMessage, helperInErrorState } from '../util/FieldHelperUtil';
import { IFormHelperProps, PassField, Separator } from '@teliaee/design-system';
import { Passwords, confirmPasswordFieldIsEqual, isPasswordStrong } from '../util/ValidationUtil';
import { observer } from 'mobx-react';

interface PasswordFormFieldsProps {
  translate: (key: string) => string;
  emailLoginPasswords: Passwords;
  passwordHelper?: IFormHelperProps | undefined;
  confirmPasswordHelper?: IFormHelperProps | undefined;
  hasSubmitted?: boolean;
  isDisabled?: boolean;
}

export const PasswordFormFields = observer((props: PasswordFormFieldsProps): React.JSX.Element => {
  const { translate, emailLoginPasswords, passwordHelper, confirmPasswordHelper, hasSubmitted, isDisabled } = props;

  return (
    <>
      <PassField
        label={translate('password.password_label')}
        id="newPassword"
        isDisabled={isDisabled}
        value={emailLoginPasswords.password}
        onChange={(value) => (emailLoginPasswords.password = value)}
        isInvalid={helperInErrorState(passwordHelper)}
        errorMessage={getHelperErrorMessage(passwordHelper)}
        required={true}
      />
      <Separator spacing="xxsmall" color="invisible" />
      <PassField
        label={translate('password.confirm_label')}
        id="confirmPassword"
        isDisabled={isDisabled}
        value={emailLoginPasswords.confirmPassword}
        onChange={(value) => (emailLoginPasswords.confirmPassword = value)}
        isInvalid={hasSubmitted && isPasswordStrong(emailLoginPasswords.password) && !confirmPasswordFieldIsEqual(emailLoginPasswords)}
        errorMessage={isPasswordStrong(emailLoginPasswords.password) ? getHelperErrorMessage(confirmPasswordHelper) : undefined}
        required={true}
      />
    </>
  );
});
